"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatSelectedFiltersForDisplay = exports.useSelectedFilters = void 0;
const react_1 = require("react");
const useSelectedFilters = () => {
    const [selectedFilters, setSelectedFilters] = (0, react_1.useState)({});
    const updateSelectedFilter = (0, react_1.useCallback)((filterName, selectedIds) => {
        setSelectedFilters(prevFilters => (Object.assign(Object.assign({}, prevFilters), { [filterName]: selectedIds })));
    }, []);
    const clearSelectedFilters = (0, react_1.useCallback)(() => {
        setSelectedFilters({});
    }, []);
    return { selectedFilters, updateSelectedFilter, clearSelectedFilters };
};
exports.useSelectedFilters = useSelectedFilters;
const formatSelectedFiltersForDisplay = (selectedFilters, filters) => {
    return Object.entries(selectedFilters).reduce((acc, [filterName, selectedIds], index, array) => {
        const filterData = filters[filterName];
        const filterTitle = (filterData === null || filterData === void 0 ? void 0 : filterData.title) || filterName;
        const selectedLabels = (filterData === null || filterData === void 0 ? void 0 : filterData.options.filter(option => selectedIds.includes(option.value)).map(option => option.label)) || [];
        acc += `${filterTitle}: ${selectedLabels.join(', ')}${index < array.length - 1 ? ', ' : ''}`;
        return acc;
    }, '');
};
exports.formatSelectedFiltersForDisplay = formatSelectedFiltersForDisplay;
//   export default useSelectedFilters;
